import {useState} from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Form from '../common/Form';

import {useCreateLocationMutation} from '../../redux/services/locationApi';

const sections = [
  {name: 'basic', label: '⚙️ Basic Info'},
  {name: 'address', label: '📍 Address'},
];

const fields = () => [
  {
    section: 'basic',
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    placeholder: 'Trainer\'s Club',
  },
  {
    section: 'basic',
    name: 'category',
    label: 'Category',
    type: 'select',
    required: true,
    options: [
      {label: 'Partner Facility', value: 'FACILITY'},
      {label: 'Team Location', value: 'TEAM'},
    ],
  },
  {
    section: 'basic',
    name: 'description',
    label: 'Description',
    type: 'textarea',
    required: false,
    rows: 2,
    placeholder: 'A great place to get physical therapy!',
  },
  {
    section: 'basic',
    name: 'phone_number',
    label: 'Phone Number',
    type: 'phone',
    required: false,
    placeholder: '(555) 123-4567',
  },
  {
    section: 'address',
    name: 'address',
    label: 'Address',
    type: 'address',
    placeholder: '123 Main St, Anytown, USA',
    useGeocoding: true,
    required: true,
  },
];

const handleSubmit = ({create, setError, setSuccess}) => async formData => {
  console.log('Creating location', formData);
  setSuccess(null);
  setError(null);
  const response = await create(formData);
  if (response.error) {
    console.error('Failed to create location', response.error);
    setError(response.error);
  } else {
    setSuccess(true);
  }
};

const serialize = formData => {
  const {address, ...rest} = formData;
  return {
    ...rest,
    ...address,
  };
};

const NewLocationForm = props => {
  const defaultData = {
    category: 'FACILITY',
    name: null,
    address_line_1: '',
    address_line_2: '',
    address_city: '',
    address_state: '',
    address_zip: '',
    lat: null,
    lon: null,
  };
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [create] = useCreateLocationMutation();
  const onSubmit = handleSubmit({create, setError, setSuccess});
  return (
    <Stack spacing={4} alignItems='center'>
      <Container maxWidth='xs' justifyContent='center' alignItems='center'>
        <Grid container spacing={1} padding={2}>
          {
            success && <Grid item xs={12}>
              <Alert severity='success'>Location created successfully!</Alert>
            </Grid>
          }
          {
            error && <Grid item xs={12}>
              <Alert severity='error'>{error?.data || 'Failed to create location'}</Alert>
            </Grid>
          }
          <Form
            fields={fields()}
            sections={sections}
            defaultValues={defaultData}
            onSubmit={onSubmit}
            serializer={serialize}
          />
        </Grid>
      </Container>
    </Stack>
  );
};

export default NewLocationForm